// extracted by mini-css-extract-plugin
export default {"card":"ImgOneLine_card__2Q6Hq","card_img":"ImgOneLine_card_img__K+vnv"};